export const offline = navigator.onLine === false;

export const controller = {
        skills : "api/skills",
        skillCenters : "api/skillCenters",
        businessMgt: "api/business-management",
        activity:"api/activity",
}
